// plugins
import './plugins/vee-validate'
import './plugins/vue-select'
import './plugins/vue-slider'
import './plugins/vue-good-table'
import Teleport from 'vue2-teleport';
import TipScope from './plugins/tip-scope'


Vue.component('c-teleport', Teleport)
Vue.directive('tip-scope', TipScope)
// forms
Vue.component('c-input', require('./ui/forms/c-input').default)
Vue.component('app-input', require('./ui/forms/app-input').default)
Vue.component('app-select', require('./ui/forms/app-select').default)
Vue.component('app-searchable-select', require('./ui/forms/app-searchable-select').default)
Vue.component('app-checkbox', require('./ui/forms/app-checkbox').default)
Vue.component('app-toggle', require('./ui/forms/app-toggle').default)
Vue.component('app-checkbox-group', require('./ui/forms/app-checkbox-group').default)
Vue.component('app-radio', require('./ui/forms/app-radio').default)
Vue.component('app-radio-group', require('./ui/forms/app-radio-group').default)
Vue.component('app-textarea', require('./ui/forms/app-textarea').default)
Vue.component('app-table', require('./shared/app-table/index').default)
Vue.component('app-badge', require('./ui/badges/app-badge').default)
Vue.component('app-skeleton', require('./ui/components/app-skeleton').default)
Vue.component('app-table-skeleton', require('./ui/components/app-table-skeleton').default)
Vue.component('app-empty-state', require('./ui/components/app-empty-state').default)
Vue.component('app-alert', require('./ui/components/app-alert').default)
Vue.component('app-pagination', require('./ui/components/app-pagination').default)
Vue.component('app-tooltip', require('./ui/components/AppTooltip').default)
Vue.component('c-textarea', require('./ui/forms/c-textarea').default)
Vue.component('c-datepicker', require('./ui/forms/c-datepicker').default)
Vue.component('c-select', require('./ui/forms/c-select').default)
Vue.component('c-dropdown', require('./ui/forms/c-dropdown.vue').default)
Vue.component('c-checkbox', require('./ui/forms/c-checkbox').default)
Vue.component('c-editor', require('./ui/forms/c-editor').default)
Vue.component('c-datepicker', require('./ui/forms/c-datepicker').default)
Vue.component('c-radio', require('./ui/forms/c-radio').default)
Vue.component('c-radio-group', require('./ui/forms/c-radio-group').default)
Vue.component('c-checkbox-group', require('./ui/forms/c-checkbox-group').default)
Vue.component('c-upload', require('./ui/forms/c-upload').default)
Vue.component('c-upload-image', require('./ui/forms/c-upload-image').default)
Vue.component('app-attachment', require('./ui/forms/app-attachment').default)
Vue.component('c-button', require('./ui/forms/c-button').default)
Vue.component('c-button-help', require('./ui/forms/c-button-help').default)
Vue.component('c-button-link', require('./ui/forms/c-button-link').default)
Vue.component('c-input-group', require('./ui/forms/c-input-group').default)
Vue.component('c-icon-background', require('./ui/icons/c-icon-background').default)
Vue.component('app-icon', require('./ui/icons/app-icon').default)

Vue.component('c-sidebar', require('./components/c-sidebar').default)
// Vue.component('app-topbar', require('./components/app-topbar').default)

// Page content wrappers — consistent 4-edge padding for page bodies.
Vue.component('app-page', require('./components/app-page').default)
Vue.component('app-page-sidebar', require('./components/app-page-sidebar').default)

Vue.component('c-spinner', require('./ui/components/Spinner').default)
Vue.component('c-avatar-plug', require('./ui/components/AvatarPlug').default)
Vue.component('c-loader', require('./ui/components/Loader').default)
Vue.component('c-clipboard-btn', require('./ui/components/ClipboardBtn').default)
Vue.component('c-list-error', require('./ui/components/ListError').default)
Vue.component('c-list-empty', require('./ui/components/ListEmpty').default)
Vue.component('c-status-message', require('./ui/components/StatusMessage').default)
Vue.component('header-with-help-button', require('./ui/components/HeaderWithHelpButton').default)
Vue.component('c-sortable-item', require('./ui/components/SortableItem').default)

Vue.component('c-modal', require('./ui/modals/c-modal').default)
Vue.component('c-confirm-delete-modal', require('./ui/modals/c-confirm-delete-modal').default)
Vue.component('items-crud-list', require('./ui/components/ItemsCrudList').default)
Vue.component('item-crud', require('./ui/components/ItemCrud').default)
Vue.component('preview-email-content', require('./ui/components/PreviewEmailContent').default)
Vue.component('block-flat', require('./ui/components/BlockFlat').default)
Vue.component('c-icon-badge', require('./ui/components/CIconBadge').default)
Vue.component('section-card', require('./ui/components/SectionCard').default)
Vue.component('section-header', require('./ui/components/SectionHeader').default)
Vue.component('section-short-text', require('./ui/components/SectionShortText').default)
Vue.component('section-empty', require('./ui/components/SectionEmpty').default)
Vue.component('app-button', require('./ui/forms/app-button').default)
Vue.component('app-icon-button', require('./ui/forms/AppIconButton').default)
Vue.component('app-fieldset', require('./ui/components/AppFieldset').default)
Vue.component('app-stack', require('./ui/components/AppStack').default)
Vue.component('app-header', require('./ui/components/AppHeader').default)
Vue.component('app-breadcrumbs', require('./ui/components/AppBreadcrumbs').default)
Vue.component('content-nav', require('./ui/components/ContentNav').default)
Vue.component('filter-strip', require('./ui/components/FilterStrip').default)
Vue.component('tab-nav', require('./ui/components/TabNav').default)
Vue.component('page-tabs', require('./ui/components/PageTabs').default)
Vue.component('info-banner', require('./ui/components/InfoBanner').default)
Vue.component('c-badge', require('./ui/components/CBadge').default)
Vue.component('event-form-builder-form', require('./shared/event-form-builder-form').default)


// pages
Vue.component('dashboard-logo', require('./shared/registrants/dashboard-customization/dashboard-logo').default)
Vue.component('shared-custom-branding', require('./shared/sequences/custom-branding').default)

// TODO create directive folder and move it
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent, true)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent, true)
  },
});